// ファイルダウンロード
export const fileDownloadResponseResolver = {
	type: ["application/force-download", "application/octet-stream"],
	async resolve (response) {
		var contentDisposition = response.headers.get("Content-Disposition")
		var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
		var matches = filenameRegex.exec(contentDisposition)
		var fileName = "download"
		if (matches != null && matches[1]) {
			fileName = decodeURI(matches[1].replace(/['"]/g, ""))
		}
		// レスポンスのblobを隠しaタグから疑似的にダウンロードする。
		const blob = await response.blob()
		var pseudoDownloadUrl = URL.createObjectURL(blob)
		var a = document.createElement("a")
		a.style = "display: none;"
		a.href = pseudoDownloadUrl
		a.download = fileName
		document.body.appendChild(a)
		a.click()
		requestAnimationFrame(() => {
			a.remove()
			URL.revokeObjectURL(pseudoDownloadUrl)
		})
		return blob
	}
}

// jsonレスポンス
export const jsonResponseResolver = {
	type: ["application/json"],
	async resolve (response) {
		return await response.json()
	}
}
